'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var VAppContainer = function (_a) {
  var _b = _a.className,
      className = _b === void 0 ? '' : _b,
      children = _a.children;
  var classList = "vapp-container ".concat(className);
  return React__default["default"].createElement("div", {
    className: classList
  }, children);
};

exports["default"] = VAppContainer;
